<template>
  <div class="inventory-container">
    <v-btn
      small
      text
      color="error"
      @click="$emit('input', false)"
      style="position: absolute; top: 0px; right: -10px;"
    >
      <!-- -->
      <v-icon class="ma-2">mdi-close-octagon</v-icon>
      
    </v-btn>
    <h4 class="ma-4 pt-4">
      Record a video of your home, room, or office. After clicking Finish button
      AI will analyze the footage and generate a detailed inventory list for
      your move, including estimated volume of each item.
    </h4>
    <!-- <v-btn @click="$emit('input', false)">Close</v-btn> -->
    <v-alert
      class="ma-2"
      dismissible
      dense
      timeout="3000"
      v-if="errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>

    <div v-if="loading">
      <i class="mdi mdi-loading mdi-spin ma-2"></i>
      Analyzing your video ...
    </div>

    <!-- Hidden mobile input -->
    <input
      type="file"
      accept="video/*"
      capture="environment"
      @change="triggerUpload"
      ref="mobileInput"
      style="display: none"
    />
    <!-- <v-btn
      small
      text
      color="secondary"
      class="mr-2"
      v-if="isMobile"
      @click="$refs.mobileInput.click()"
    >
      <v-icon>mdi-camera</v-icon>
      Upload From Camera
    </v-btn> -->
    <!-- Desktop recorder -->
    <div class="video-wrapper" v-if="!inventoryFinished">
      <div>
        <video
          ref="video"
          autoplay
          playsinline
          muted
          style="max-height: 100%; width: auto"
        ></video>
        <div class="video-controls ma-2">
          <div class="button-row">
            <v-btn
              small
              text
              color="primary"
              @click="startCamera"
              v-show="!recording && !paused"
              class="mr-2"
            >
              <v-icon>mdi-record-rec</v-icon>
              Start Recording
            </v-btn>
            <v-btn
              small
              text
              color="orange"
              v-show="recording && !paused"
              @click="pauseAndUploadFrame"
            >
              <v-icon>mdi-pause-circle</v-icon>
              Pause
            </v-btn>
            <v-btn
              small
              text
              color="blue"
              v-show="paused"
              @click="resumeRecording"
            >
              <v-icon>mdi-play-circle</v-icon>
              Resume
            </v-btn>

            <v-btn
              v-show="recording"
              small
              text
              color="success"
              @click="stopCamera"
            >
              <!-- -->
              <v-icon class="ma-2">mdi-stop-circle</v-icon>
              Finish
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  name: "InventoryVideoUploader",

  data() {
    return {
      stream: null,
      intervalId: null,
      loading: false,
      inventoryFinished: false,
      inventory: [],
      recording: false,
      errorMessage: "",
      durationSec: 0,
      threadId: null,
      assistant_id: "asst_gpLKiNsoVdUmRwBcqCIZqu1N",
      serverURL: "",
      paused: false,
      uploadCount: 0,
      prompt: "",
    };
  },
  computed: {
    totalVolume() {
      return this.inventory.reduce(
        (sum, item) => sum + (item.cu_ft * item.quantity || 0),
        0
      );
    },
    isMobile() {
      return /Mobi|Android/i.test(navigator.userAgent);
    },
  },
  mounted() {
    this.serverURL = fun.getServerURL();
    // if (!this.assistant_id) {
    //   this.createAssistantId();
    // }
    const url = "get_data";
    const data = {
      object_name: "ai_settings",
      qry: {
        ai_name: "InventoryHelper",
      },
    };
    axios
      .post(this.serverURL + "/" + url, data, {
        withCredentials: true,
      })
      .then((response) => {
        if (!response.data.model.length) {
          this.errorMessage = "AI hasn't been setup yet";
          return;
        }
        this.prompt = response.data.model[0].prompt;
        console.log(this.prompt);

        this.setupCamera();
      });
  },
  methods: {
    setupCamera() {
      var url = "reset_inventory";
      axios
        .post(
          this.serverURL + "/" + url,
          {},
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          // if (!this.isMobile) {
          this.uploadCount = 0;
          navigator.mediaDevices
            .getUserMedia({
              video: { facingMode: "environment" },
              audio: false,
            })
            .then((stream) => {
              this.stream = stream;
              const video = this.$refs.video;
              if (video) video.srcObject = stream;
            })
            .catch((err) => {
              console.error("Camera setup error:", err);
              this.errorMessage = "Failed to access camera.";
            });
          // }
        });

      //
    },
    triggerUpload() {
      this.$refs.mobileInput.click();
    },
    createAssistantId() {
      //   this.loading = true;
      var url = "create_inventory_assistant";
      var data = {};

      axios
        .post(this.serverURL + "/" + url, data, {
          withCredentials: true,
        })
        .then((res) => {
          this.loading = false;
          this.assistant_id = res.data.assistant_id;
        })
        .catch((err) => {
          //   console.error("Thread initialization error:", err);
          this.errorMessage = "Unable to create assistant.";
          this.loading = false;
        });
    },
    initSessionAndStartCamera() {
      //   this.loading = true;
      var url = "start_inventory_thread";
      var data = {};

      axios
        .post(this.serverURL + "/" + url, data, {
          withCredentials: true,
        })
        .then((res) => {
          this.loading = false;
          this.threadId = res.data.thread_id.id;
          this.startCamera();
        })
        .catch((err) => {
          console.error("Thread initialization error:", err);
          this.errorMessage = "Unable to start session.";
          this.loading = false;
        });
    },
    startCamera() {
      this.recording = true;
      this.durationSec = 0;
      const video = this.$refs.video;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      this.intervalId = setInterval(() => {
        this.durationSec++;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.width = 320;
        canvas.height = 240;

        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const base64 = canvas.toDataURL("image/jpeg").split(",")[1];

        // canvas.toBlob((blob) => {
        //   const formData = new FormData();
        //   formData.append("frame", blob);
        //   // formData.append("thread_id", this.threadId);
        //   // formData.append("assistant_id", this.assistant_id);
        this.uploadCount += 1;

        axios
          .post(
            this.serverURL + "/upload_frame",
            { image_base64: base64 },
            {
              withCredentials: true,
              headers: { "Content-Type": "application/json" },
            }
          )
          .catch((err) => {
            console.error("Frame upload error:", err);
          });
      }, 1000);

      this.loading = false;
    },
    pauseAndUploadFrame() {
      if (!this.recording || !this.$refs.video) return;
      this.paused = true;

      const video = this.$refs.video;
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const base64 = canvas.toDataURL("image/jpeg").split(",")[1];

      this.recording = false; // optional: prevent more frames until resumed

      axios
        .post(
          this.serverURL + "/upload_frame",
          { image_base64: base64 },
          {
            withCredentials: true,
            headers: { "Content-Type": "application/json" },
          }
        )
        .then(() => {
          console.log("Frame uploaded");
        })
        .catch((err) => {
          console.error("Frame upload error (pause):", err);
        });
    },
    resumeRecording() {
      this.paused = false;
      this.recording = true;
    },
    prepareInventory(inventoryList) {
      var that = this;
      inventoryList.forEach((i) => {
        var invItem = {
          item: i.item,
          qty: i.quantity,
          volume: i.cu_ft,
          weight: i.cu_ft * 7,
          total_volume: i.cu_ft * i.quantity,
          from: that.from,
          to: that.to,
          service_date: that.service_date,
        };
        this.shipmentInventory.push(invItem);
      });
    },
    stopCamera(retry) {
      var startTime = Date.now();
      if (!retry) {
        startTime = Date.now();
        if (!this.isMobile) {
          if (this.intervalId) clearInterval(this.intervalId);
          if (this.stream) {
            this.stream.getTracks().forEach((track) => track.stop());
          }
        }

        this.recording = false;
        this.inventoryFinished = true;

        this.durationSec = 0;
        this.loading = true;
      }

      var that = this;
      var data = {
        expected_count: this.uploadCount,
        prompt: this.prompt,
      };

      axios
        .post(this.serverURL + "/finish_inventory", data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.waiting) {
            console.log("Still waiting on frames...");
            setTimeout(this.stopCamera(true), 500); // retry in 0.5s
          } else {
            const endTime = Date.now();
            this.durationSec = ((endTime - startTime) / 1000).toFixed(2);
            this.loading = false;
            this.prepareInventory(res.data.inventory);
            // console.log(that.shipmentInventory)
            this.$emit("input", false);
          }
        })
        .catch((err) => {
          console.error("Fetch inventory error:", err);
          this.loading = false;
        });
    },
  },
  props: {
    from: String,
    to: String,
    service_date: String,
    shipmentInventory: Array,
    vModel: Boolean,
  },
};
</script>

<style scoped>
.inventory-container {
  /* display: flex;
  flex-direction: column; */
  background-color: white;
  position: relative;
  height: 80vh;
  z-index: 100;
}

h3 {
  flex: 0 0 auto;
}

.video-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.video-feed {
  flex: 1;
  width: 100%;
  object-fit: cover;
  background: black;
}

.video-controls {
  flex: 0 0 auto;
  /* padding: 10px;
  display: flex;
  justify-content: left; */
  position:absolute;
  bottom:0;
  background: white;
}
.v-list-item {
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: flex-start !important;
  gap: 8px !important;
}
/* .button-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 8px;
} */

.v-list-item .v-btn {
  flex: 1 1 auto;
  min-width: 120px;
}
video {
  border: 2px solid #ccc;
  margin-bottom: 20px;
}
</style>
